module.exports = __webpack_public_path__ + "static/img/anhui.6a257a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/screen38496/influence-zone/anhui.png
// module id = RI3N
// module chunks = 1